import { render, staticRenderFns } from "./component-chatEditor.vue?vue&type=template&id=e94675a4&scoped=true&"
import script from "./component-chatEditor.vue?vue&type=script&lang=js&"
export * from "./component-chatEditor.vue?vue&type=script&lang=js&"
import style0 from "./component-chatEditor.vue?vue&type=style&index=0&id=e94675a4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e94675a4",
  null
  
)

export default component.exports